import { gql } from '@apollo/client/core';

//TODO refaire la route graphql sur user
export const UPDATE_OPTIONS = gql`
  mutation updateUserOptions($key: String, $data: String) {
    updateOptions(key: $key, data: $data) {
      firstname
      lastname
      options
    }
  }
`;
